var _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalleryView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 45,
    viewBox: "0 0 70 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 69.25,
    height: 44.25,
    rx: 6.625,
    stroke: "#6A27EA",
    strokeWidth: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.8,
    rx: 2,
    transform: "matrix(1 0 0 -1 36 35)",
    fill: "#6A27EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.8,
    rx: 2,
    transform: "matrix(1 0 0 -1 36 21.8)",
    fill: "#6A27EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.8,
    rx: 2,
    transform: "matrix(1 0 0 -1 20 35)",
    fill: "#6A27EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.8,
    rx: 2,
    transform: "matrix(1 0 0 -1 20 21.8)",
    fill: "#6A27EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryView);
export default __webpack_public_path__ + "static/media/galleryView.6cfb7fdf03a36dad9e8b74bc1fefaf3c.svg";
export { ForwardRef as ReactComponent };